import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postMatchmakerInviteOpen,
  type PostMatchmakerInviteOpenParams,
  type PostMatchmakerInviteOpenResponse,
} from '@services/MatchmakerService';

export type UsePostMatchmakerInviteOpenParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostMatchmakerInviteOpenResponse,
    unknown,
    string,
    PostMatchmakerInviteOpenParams,
    PostMatchmakerInviteOpenResponse
  >;
};

export const postMatchmakerInviteOpenMutationKey =
  'post-matchmaker-invite-open';

export const usePostMatchmakerInviteOpen = ({
  mutationOptions,
}: UsePostMatchmakerInviteOpenParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostMatchmakerInviteOpenResponse,
    unknown,
    string,
    PostMatchmakerInviteOpenParams
  >(
    postMatchmakerInviteOpenMutationKey,
    (_url, { arg }) => postMatchmakerInviteOpen(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
